import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { describeCron } from '../../../lib/formatters/cron';

// Draggable scheduled block (T7.6). Rendered inside its row's lane; the drag
// handle is the block itself. Position is percentage-based over 24h.
function TimelineBlock({ job, hoursVisible = 24, onEdit }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id: job.id });

  const style = {
    width: `${(job.durationHours / hoursVisible) * 100}%`,
    left: `${(job.startHour / hoursVisible) * 100}%`,
    transform: CSS.Translate.toString(transform),
    transition
  };

  return (
    <button
      {...attributes}
      {...listeners}
      className={`timeline-block ${isDragging ? 'is-dragging' : ''}`}
      onDoubleClick={onEdit}
      ref={setNodeRef}
      style={style}
      title={`${job.title} — ${describeCron(job.cron)}`}
      type="button"
    >
      <span className="timeline-block-time">{String(job.startHour).padStart(2, '0')}:00</span>
      <span className="timeline-block-title">{job.title}</span>
    </button>
  );
}

export default TimelineBlock;
